const getCookieByName = (name, encode = false) => {
  const match = document.cookie.match(new RegExp(name + "=([^;]+)"));
  let cookieValue;
  if (match) {
    if (encode) {
      cookieValue = decodeURIComponent(match[1]);
    } else {
      cookieValue = match[1];
    }
    return cookieValue;
  }
};
export {
  getCookieByName
};
